<form [formGroup]="modalForm" (submit)="saveLogin()" class="modal-top large-modal">
    <!-- <mat-dialog-title></mat-dialog-title>
     -->
    <!--  -->
    <div class="container-icon">
        <button mat-button mat-dialog-close class="btn-closeIcon">
            <icon-x class="h-6 w-6" />
        </button>
    </div>
    <mat-dialog-content >
        <div class="content p-4">
            <div class="row">
                <div class="col-lg-12">
                    <div class="text-center">
                        <img class="img-fluid rounded mx-auto help-to-center" src="icon.png" alt="Logo App">
                    </div>
                </div>
                <p class="h5 mt-4">Accede con tu cuenta</p>
                <div action="" class="mt-4">
                    <div class="form-group mb-3">
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="user" placeholder="Email" aria-label="Email" aria-describedby="basic-addon2">
                        </div>
                        <small id="error-password" class="form-text text-danger"
                            *ngIf="fieldValidated(modalForm,'password')">
                            @if (f['password'].errors!['required']) {
                            <div>Ingrese su usuario</div>
                            }
    
                        </small>
                    </div>
                    <div class="form-group mb-3">
                        <div class="input-group" [ngClass]="{'has-error': failPassword !=''}">
                            <input [type]="isPasswordVisible ? 'text' : 'password'" class="form-control" formControlName="password" placeholder="Contraseña" aria-label="Contraseña" aria-describedby="basic-addon2">
                            <div class="input-group-append">
                              <button class="button-eye" (click)="isPasswordVisible = !isPasswordVisible" type="button"><icon-eye class="h-6 w-6" /></button>
                            </div>
                        </div>
                        <small id="error-password" class="form-text text-danger"
                            *ngIf="fieldValidated(modalForm,'password')">
                            @if (f['password'].errors!['required']) {
                            <div>Ingrese su contraseña</div>
                            }
    
                        </small>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="grid grid-cols-1 sm:grid-cols-1 gap-2">
            <div class="relative text-white-dark">
                <div class="flex" [ngClass]="{'has-error': failPassword !=''}">
                    <input id="passwordAccess" formControlName="passwordAccess"
                        [type]="isPasswordVisible ? 'text' : 'password'"
                        placeholder="Ingrese su contraseña" autocomplete="off"
                        class="form-control ps-10 placeholder:text-white-dark" />
                    <input id="passwordAccess" formControlName="passwordAccess"
                        [type]="isPasswordVisible ? 'text' : 'password'"
                        placeholder="Ingrese su contraseña" autocomplete="off"
                        class="form-control ps-10 placeholder:text-white-dark" />
                    <button type="button" (click)="isPasswordVisible = !isPasswordVisible"
                        class="btn btn-white ltr:rounded-l-none rtl:rounded-r-none"
                        style="border: 0px;box-shadow: none;position: absolute;padding: 4px;right: 4px;top:2px;">
                        <icon-eye class="h-6 w-6" />
                    </button>
                </div>
            </div>
        </div> -->
    </mat-dialog-content>
    <mat-dialog-actions>
        <div class="d-grid gap-2 col-6 mx-auto mb-4">
            <button type="submit" class="btn btn-primary" [disabled]="loading">Acceder
                @if(loading){
                <span
                    class="animate-spin border-2 border-white border-l-transparent rounded-full w-5 h-5 ltr:mr-4 rtl:ml-4 inline-block align-middle"></span>
                }</button>
        </div>
    </mat-dialog-actions>
</form>